import { Component, ElementRef, HostListener, OnInit } from "@angular/core";
import { CommonService } from "../../../shared/common.service";
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { MainService } from "../../../../../src/app/main/main.service";
import { NavigationStart, Router } from "@angular/router";
import { MatSnackBar } from "@angular/material";

@Component({
  selector: "app-main-header",
  templateUrl: "./main-header.component.html",
  styleUrls: ["./main-header.component.css"],
  template: `
    <h2 mat-dialog-title>Confirm Logout</h2>
    <mat-dialog-content>Are you sure you want to log out?</mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="warn" (click)="onConfirm()">Yes, Logout</button>
    </mat-dialog-actions>
  `
})




// @Component({
//   selector: 'app-logout-confirm-dialog',
  
// })
export class MainHeaderComponent implements OnInit {
  userData: any = {};
  userProfilePic: any;
  profilePic: string = "";
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
  };
  routeUrl: any;
  closeResult: string;
  private modalRef: NgbModalRef;
  public notificationCount: number = 0;
  isDropdownOpen = false;
  constructor(
    private commonService: CommonService,
    private modalService: NgbModal,
    private mainService: MainService,
    private router: Router,
    private _snackBar: MatSnackBar,
    private eRef: ElementRef,
  ) {this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.isDropdownOpen = false;
      }
    });}

toggleDropdown(status: boolean): void {
  this.isDropdownOpen = status;
}

  // @HostListener('document:click', ['$event'])
  // handleClickOutside(event: Event) {
  //   if (!this.eRef.nativeElement.contains(event.target)) {
  //     this.isDropdownOpen = false;
  //   }
  // }
  openLogoutModal(content: any) {
  this.modalService.open(content, {
    backdrop: 'static',
    centered: true,
  });
}

confirmLogout(modal: any) {
  modal.close();

  // 👉 Your logout logic here
  localStorage.clear();
  this._snackBar.open('Logged out successfully ✅', 'Close', {
    duration: 3000,
    horizontalPosition: 'right',
    verticalPosition: 'top',
    panelClass: ['alert-success'],
  });

  this.router.navigate(['/auth/login']);
}


  ngOnInit(): void {
    this.getUnreadNotificationCount();
    setTimeout(() => {
      let user: any = localStorage.getItem("userData");
      let newUser = JSON.parse(user);
      this.userProfilePic = newUser.profilePic;
      // if(newUser.profilePic != ""){
      //   this.profilePic=newUser.profilePic;
      // }
    }, 0);
    this.routeUrl = this.router.url;
    this.getuserProfile();
    this.getNotiDetail2();

    setTimeout(() => {
      this.routeUrl = this.router.url; // /main/pending-booking
      this.getuserProfile();
    this.getNotiDetail2();

    }, 2000);

    setInterval(() => {
      this.getNotiDetail2();
      this.getUnreadNotificationCount();
    }, 20000);

    this.userData = this.commonService.getUser();

    const baseUrl = window.location.origin; // http://localhost:8909 or the domain of your app

    // const fullUrl = `${baseUrl}${routeUrl}`;
    // console.log("Full URL:", fullUrl);
    // console.log(baseUrl, "base Url");
    console.log(this.routeUrl, "route url");
  }
  showHead: boolean = false;
  showHideHead() {
    if (this.showHead == true) {
      this.showHead = false;
    } else {
      this.showHead = true;
    }
  }
  viewHandbook(event: Event) {
    event.preventDefault();
    window.open(
      "https://s3.ap-south-1.amazonaws.com/codknox/acc/1727414117153_ACC_handbook_2024__1_.pdf",
      "_blank"
    );
  }
  uniformRedirect() {
    window.open("https://www.frenchtoast.com/", "_blank");
  }

  OpenModal(content, btn) {
    this.modelOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      size: "lg",
    };
    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  closeModal() {
    this.modalRef.close();
    // this.selectedActivity = [];
    // this.allSelectedActivities = [];
    // this.selectedActivities = []
    // this.allSelectedActivities = JSON.parse(localStorage.getItem('allactivity'));
    // this.selectedActivities = JSON.parse(localStorage.getItem('activityInput'));
  }
  isLoading: any;
  notiData: any = [];
  getNotiDetail(content, btn) {
    // this.isLoading = true;
    // this.mainService.getNoti().subscribe(
    //   (res) => {
    //     if (res["message"] == "Success") {
    //       this.notiData = res.data.list;
          this.OpenModal(content, btn);
      //   } else {
      //   }
      // },
      // (err) => {}
    // );
  }

  // this.updateUser(req).subscribe((res) => {

  // });
  pendingBookings;
  getuserProfile() {
    this.mainService.updateUser("").subscribe(
      (res) => {
        if (res["message"] == "Success") {
          this.pendingBookings = res.data.response.isPendingBooking;
          console.log(this.pendingBookings, " this.pendingBookings");

          if (
            this.pendingBookings &&
            this.routeUrl != "/main/pending-booking"
          ) {
            let snackBarRef = this._snackBar.open("Payment Pending", "View", {
              duration: 5000,
              horizontalPosition: "center",
              verticalPosition: "top",
              panelClass: ["alert-warning", "blinking-snackbar"],
            });

            snackBarRef.onAction().subscribe(() => {
              this.router.navigate(["/main/pending-booking"]);
            });
          }

          console.log(res, "response");
        } else {
        }
      },
      (err) => {}
    );
  }

  getNotiDetail2() {
    // this.isLoading = true;
    this.mainService.getNoti().subscribe(
      (res) => {
        if (res["message"] == "Success") {
          this.notiData = res.data.notifications;
        } else {
        }
      },
      (err) => {}
    );
  }


 getUnreadNotificationCount() {
  this.mainService.getUnreadNotificationCount().subscribe(
    (res) => {
      if (res["message"] === "Success") {
        this.notificationCount = res?.data?.count || 0;
      } else {
        this.notificationCount = 0;
      }
    },
    (err) => {
      this.notificationCount = 0;
    }
  );
}

  openPaymentWindow(content: any) {
    const bookingDetailId = this.extractQueryParam(content, "bookingDetailId");

     /*
    For Dev, use the following success URL:
    */

    // const successUrl = "https://webacc.codknox.com/main/home";

    /*
    For Production, use the following success URL:
    */
   
    const successUrl = "https://web.adventchildrenschoir.org/main/home";

    if (bookingDetailId && successUrl) {
      let query = `bookingDetailId=${bookingDetailId}`;

      this.mainService.createStripe(query).subscribe((res) => {
        this.isLoading = false;
        if (res["message"] === "Success" || res["statusCode"] === 200) {
          window.open(res.data.sessionUrl, "_self");
          console.log(res, "response of stripe checkout");
        }
      });
    } else {
      console.error("Required parameters not found in content.");
    }
  }

  // Helper function to extract query parameters
  extractQueryParam(content: string, param: string): string | null {
    const url = content.split("here:")[1];
    const urlParams = new URLSearchParams(url.split("?")[1]);

    return urlParams.get(param);
  }

  convertStamp(timeToConvert: number): string {
    let time = timeToConvert;
    if (time < 1000000000000) {
      time *= 1000;
    }
    const now = new Date().getTime();
    if (time > now || time <= 0) {
      return "Just now";
    }
    const diff = now - time;
    const SECOND_MILLIS = 1000;
    const MINUTE_MILLIS = 60 * SECOND_MILLIS;
    const HOUR_MILLIS = 60 * MINUTE_MILLIS;
    const DAY_MILLIS = 24 * HOUR_MILLIS;

    if (diff < MINUTE_MILLIS) {
      return "just now";
    } else if (diff < 2 * MINUTE_MILLIS) {
      return "1 min ago";
    } else if (diff < 50 * MINUTE_MILLIS) {
      return Math.floor(diff / MINUTE_MILLIS) + " min ago";
    } else if (diff < 90 * MINUTE_MILLIS) {
      return "1h ago";
    } else if (diff < 24 * HOUR_MILLIS) {
      return Math.floor(diff / HOUR_MILLIS) + "h ago";
    } else if (diff < 48 * HOUR_MILLIS) {
      return "yesterday";
    } else {
      return Math.floor(diff / DAY_MILLIS) + "d ago";
    }
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  public markAllAsRead(){
    this.mainService.markAllAsRead().subscribe((res)=>{
       if (res["message"] == "Success") {
          // this.notiData = res.data.list;
          this.modalRef.close();
          // this.OpenModal(content, btn);
        } else {
        }
    })
  }

  


}
